import React, { useState } from 'react';

// 📚 Diccionario Olayista Completo (15-20 Palabras por Unidad)
const DICTIONARY_DATABASE = {
  // --- GRADO 6° ---
  '6': {
    1: [
      { word: 'Good morning', pron: '/gʊd ˈmɔːrnɪŋ/', trans: 'Buenos días', ex: 'Good morning, teacher and classmates!' },
      { type: 'Greeting', word: 'Goodbye', pron: '/ɡʊdˈbaɪ/', trans: 'Hasta luego / Adiós', ex: 'Goodbye, see you tomorrow!' },
      { type: 'Personal Info', word: 'Last name', pron: '/læst neɪm/', trans: 'Apellido', ex: 'My last name is Alvarez.' },
      { type: 'Personal Info', word: 'First name', pron: '/fɜːrst neɪm/', trans: 'Primer nombre', ex: 'My first name is Didier.' },
      { type: 'Country', word: 'Colombia', pron: '/kəˈlʌmbiə/', trans: 'Colombia', ex: 'I am from Colombia.' },
      { type: "Nationality", word: 'Colombian', pron: '/kəˈlʌmbiən/', trans: 'Colombiano/a', ex: 'We are Colombian students at IE EOH.' },
      { type: 'Spelling', word: 'Alphabet', pron: '/ˈælfəbet/', trans: 'Alfabeto / Abecedario', ex: 'Can you spell your name using the alphabet?' },
      { type: 'Function', word: 'Repeat', pron: '/rɪˈpiːt/', trans: 'Repetir', ex: 'Can you repeat, please?' },
      { type: 'Number', word: 'Fifteen', pron: '/ˌfɪfˈtiːn/', trans: 'Quince (15)', ex: 'There are fifteen students in class.' },
      { type: 'Number', word: 'Twenty', pron: '/ˈtwenti/', trans: 'Veinte (20)', ex: 'I got twenty points in my test.' },
      { type: 'Question', word: 'Where', pron: '/wer/', trans: 'Dónde', ex: 'Where are you from?' },
      { type: 'Question', word: 'What', pron: '/wʌt/', trans: 'Qué / Cuál', ex: 'What is your favorite color?' },
      { type: 'Question', word: 'How old', pron: '/haʊ oʊld/', trans: 'Cuántos años', ex: 'How old are you?' },
      { type: 'Courtesy', word: 'Please', pron: '/pliːz/', trans: 'Por favor', ex: 'Open your book, please.' },
      { type: 'Courtesy', word: 'Thank you', pron: '/θæŋk juː/', trans: 'Gracias', ex: 'Thank you for your help.' }
    ],
    2: [
      { word: 'Mother', pron: '/ˈmʌðər/', trans: 'Madre / Mamá', ex: 'My mother cooks lunch at home.' },
      { word: 'Father', pron: '/ˈfɑːðər/', trans: 'Padre / Papá', ex: 'My father works in Medellín.' },
      { word: 'Brother', pron: '/ˈbrʌðər/', trans: 'Hermano', ex: 'My brother plays soccer.' },
      { word: 'Sister', pron: '/ˈsɪstər/', trans: 'Hermana', ex: 'My sister studies at IE EOH.' },
      { word: 'Grandmother', pron: '/ˈɡrænmʌðər/', trans: 'Abuela', ex: 'My grandmother lives in a big house.' },
      { word: 'Grandfather', pron: '/ˈɡrænfɑːðər/', trans: 'Abuelo', ex: 'My grandfather is 70 years old.' },
      { word: 'Bedroom', pron: '/ˈbedruːm/', trans: 'Dormitorio / Habitación', ex: 'I sleep in my bedroom.' },
      { word: 'Kitchen', pron: '/ˈkɪtʃɪn/', trans: 'Cocina', ex: 'We cook breakfast in the kitchen.' },
      { word: 'Bathroom', pron: '/ˈbæθruːm/', trans: 'Baño', ex: 'Wash your hands in the bathroom.' },
      { word: 'Living room', pron: '/ˈlɪvɪŋ ruːm/', trans: 'Sala de estar', ex: 'We watch TV in the living room.' },
      { word: 'His', pron: '/hɪz/', trans: 'Su (de él)', ex: 'His brother is Mateo.' },
      { word: 'Her', pron: '/hɜːr/', trans: 'Su (de ella)', ex: 'Her sister is Sofia.' },
      { word: 'Our', pron: '/aʊər/', trans: 'Nuestro/a', ex: 'Our school is IE EOH.' },
      { word: 'Their', pron: '/ðer/', trans: 'Su (de ellos)', ex: 'Their house is big.' }
    ],
    3: [
      { word: 'Wake up', pron: '/weɪk ʌp/', trans: 'Despertarse', ex: 'I wake up at 6:00 AM.' },
      { word: 'Get up', pron: '/ɡet ʌp/', trans: 'Levantarse', ex: 'She gets up early every morning.' },
      { word: 'Brush teeth', pron: '/brʌʃ tiːθ/', trans: 'Cepillarse los dientes', ex: 'I brush my teeth after breakfast.' },
      { type: 'Routine', word: 'Have breakfast', pron: '/hæv ˈbrekfəst/', trans: 'Desayunar', ex: 'We have breakfast at 6:30 AM.' },
      { type: 'Routine', word: 'Go to school', pron: '/ɡoʊ tuː skuːl/', trans: 'Ir al colegio', ex: 'They go to IE EOH at 7:00 AM.' },
      { type: 'Routine', word: 'Have lunch', pron: '/hæv lʌntʃ/', trans: 'Almorzar', ex: 'I have lunch at 12:30 PM.' },
      { type: 'Routine', word: 'Do homework', pron: '/duː ˈhoʊmwɜːrk/', trans: 'Hacer la tarea', ex: 'Sofia does her English homework in the afternoon.' },
      { type: 'Routine', word: 'Go to sleep', pron: '/ɡoʊ tuː sliːp/', trans: 'Ir a dormir', ex: 'I go to sleep at 9:00 PM.' }
    ],
    4: [
      { word: 'Mathematics', pron: '/ˌmæθəˈmætɪks/', trans: 'Matemáticas', ex: 'Math is a very useful subject.' },
      { word: 'Science', pron: '/ˈsaɪəns/', trans: 'Ciencias / Biología', ex: 'We do experiments in Science class.' },
      { word: 'History', pron: '/ˈhɪstəri/', trans: 'Historia', ex: 'History teaches us about past events.' },
      { word: 'Physical Education', pron: '/ˈfɪzɪkl ˌedʒuˈkeɪʃn/', trans: 'Educación Física', ex: 'We run in P.E. class.' },
      { word: 'Arts', pron: '/ɑːrts/', trans: 'Artes / Dibujo', ex: 'I like drawing in Arts class.' },
      { word: 'Like', pron: '/laɪk/', trans: 'Gustar', ex: 'I like studying English.' },
      { word: 'Prefer', pron: '/prɪˈfɜːr/', trans: 'Preferir', ex: 'She prefers interactive workshops.' }
    ],
    5: [
      { word: 'Can', pron: '/kæn/', trans: 'Poder (Habilidad)', ex: 'I can speak English fluently.' },
      { word: 'Cannot / Can’t', pron: '/kǽnɑːt/', trans: 'No poder', ex: 'A dog cannot fly.' },
      { word: 'Swim', pron: '/swɪm/', trans: 'Nadar', ex: 'Daniel can swim fast.' },
      { word: 'Dance', pron: '/dæns/', trans: 'Bailar', ex: 'Laura loves dancing.' },
      { word: 'Play soccer', pron: '/pleɪ ˈsɑːkər/', trans: 'Jugar fútbol', ex: 'We play soccer in physical education.' }
    ]
  },

  // --- GRADO 7° ---
  '7': {
    1: [
      { word: 'Happy', pron: '/ˈhæpi/', trans: 'Feliz / Alegre', ex: 'I am happy to learn English at IE EOH.' },
      { word: 'Sad', pron: '/sæd/', trans: 'Triste', ex: 'Why are you sad today?' },
      { word: 'Tired', pron: '/ˈtaɪərd/', trans: 'Cansado/a', ex: 'She is tired after physical education class.' },
      { word: 'Excited', pron: '/ɪkˈsaɪtɪd/', trans: 'Entusiasmado/a / Emocionado/a', ex: 'We are excited about the English contest.' },
      { word: 'Nervous', pron: '/ˈnɜːrvəs/', trans: 'Nervioso/a', ex: 'I feel nervous before exams.' },
      { word: 'Hungry', pron: '/ˈhʌŋɡri/', trans: 'Hambriento/a', ex: 'I am hungry, let us eat lunch.' },
      { word: 'Thirsty', pron: '/ˈθɜːrsti/', trans: 'Sediento/a', ex: 'Drink water if you are thirsty.' },
      { word: 'Headache', pron: '/ˈhedeɪk/', trans: 'Dolor de cabeza', ex: 'I have a headache, I need to rest.' },
      { word: 'Stomachache', pron: '/ˈstʌmək-eɪk/', trans: 'Dolor de estómago', ex: 'Sofia stayed home with a stomachache.' },
      { word: 'Toothache', pron: '/ˈtuːθeɪk/', trans: 'Dolor de muela', ex: 'You should see a dentist for a toothache.' },
      { word: 'Fever', pron: '/ˈfiːvər/', trans: 'Fiebre', ex: 'Carlos has a high fever.' },
      { word: 'Sick', pron: '/sɪk/', trans: 'Enfermo/a', ex: 'He is sick with the flu.' }
    ],
    2: [
      { word: 'Always', pron: '/ˈɔːlweɪz/', trans: 'Siempre (100%)', ex: 'I always study English.' },
      { word: 'Usually', pron: '/ˈjuːʒuəli/', trans: 'Usualmente (80%)', ex: 'She usually reads books in her free time.' },
      { word: 'Often', pron: '/ˈɔːfn/', trans: 'A menudo / Frecuentemente', ex: 'We often play soccer.' },
      { word: 'Sometimes', pron: '/ˈsʌmtaɪmz/', trans: 'A veces (50%)', ex: 'I sometimes watch movies on Fridays.' },
      { word: 'Never', pron: '/ˈnevər/', trans: 'Nunca (0%)', ex: 'He never misses English class.' },
      { word: 'Free time', pron: '/friː taɪm/', trans: 'Tiempo libre', ex: 'What do you do in your free time?' }
    ],
    3: [
      { word: 'Supermarket', pron: '/ˈsuːpərmɑːrkɪt/', trans: 'Supermercado', ex: 'We buy food at the supermarket.' },
      { word: 'Hospital', pron: '/ˈhɑːspɪtl/', trans: 'Hospital', ex: 'The hospital is near the park.' },
      { word: 'Library', pron: '/ˈlaɪbreri/', trans: 'Biblioteca', ex: 'You can study in the school library.' },
      { word: 'Bakery', pron: '/ˈbeɪkəri/', trans: 'Panadería', ex: 'I buy fresh bread at the bakery.' },
      { word: 'Next to', pron: '/nekst tuː/', trans: 'Al lado de', ex: 'The bakery is next to the pharmacy.' },
      { word: 'Behind', pron: '/bɪˈhaɪnd/', trans: 'Detrás de', ex: 'The park is behind the school.' },
      { word: 'In front of', pron: '/ɪn frʌnt ʌv/', trans: 'Enfrente de', ex: 'IE EOH is in front of the square.' }
    ],
    4: [
      { word: 'Water', pron: '/ˈwɔːtər/', trans: 'Agua (Incontable)', ex: 'Drink plenty of water every day.' },
      { word: 'Apples', pron: '/ˈæplz/', trans: 'Manzanas (Contable)', ex: 'There are three apples on the table.' },
      { word: 'Milk', pron: '/mɪlk/', trans: 'Leche (Incontable)', ex: 'Is there any milk in the fridge?' },
      { word: 'Sugar', pron: '/ˈʃʊɡər/', trans: 'Azúcar (Incontable)', ex: 'There isn\'t any sugar in my tea.' },
      { word: 'Some', pron: '/sʌm/', trans: 'Algunos / Un poco de', ex: 'There are some oranges.' },
      { type: 'Grammar', word: 'Any', pron: '/ˈeni/', trans: 'Alguno / Ninguno (Negativo/Interrogativo)', ex: 'Is there any rice?' }
    ],
    5: [
      { word: 'Yesterday', pron: '/ˈjestərdeɪ/', trans: 'Ayer', ex: 'Yesterday I studied Past Simple.' },
      { word: 'Visited', pron: '/ˈvɪzɪtɪd/', trans: 'Visitó / Visité (Pasado)', ex: 'We visited the history museum.' },
      { word: 'Played', pron: '/pleɪd/', trans: 'Jugó / Jugué (Pasado)', ex: 'He played basketball on Friday.' },
      { word: 'Went', pron: '/went/', trans: 'Fue / Fui (Pasado de GO)', ex: 'She went to school early.' },
      { word: 'Biography', pron: '/baɪˈɑːɡrəfi/', trans: 'Biografía', ex: 'We read the biography of Olaya Herrera.' }
    ]
  },

  // --- GRADO 9° ---
  '9': {
    1: [
      { word: 'Recycling', pron: '/ˌriːˈsaɪklɪŋ/', trans: 'Reciclaje', ex: 'Recycling plastic protects the planet.' },
      { word: 'Pollution', pron: '/pəˈluːʃn/', trans: 'Contaminación', ex: 'Trees help reduce air pollution.' },
      { word: 'Deforestation', pron: '/ˌdiːˌfɔːrɪˈsteɪʃn/', trans: 'Deforestación', ex: 'Deforestation damages natural habitats.' },
      { word: 'Is recycled', pron: '/ɪz ˌriːˈsaɪkld/', trans: 'Es reciclado/a (Voz Pasiva)', ex: 'Paper is recycled by 9th graders.' },
      { word: 'Are protected', pron: '/ɑːr prəˈtektɪd/', trans: 'Son protegidos/as (Voz Pasiva)', ex: 'Trees are protected in Medellín.' }
    ],
    2: [
      { word: 'Smartphone', pron: '/ˈsmɑːrtfoʊn/', trans: 'Teléfono inteligente', ex: 'Smartphones are used for learning.' },
      { word: 'Internet', pron: '/ˈɪntərnet/', trans: 'Internet', ex: 'The internet connects global education.' },
      { word: 'Used to', pron: '/juːst tuː/', trans: 'Solía / Acostumbraba a', ex: 'People used to write letters.' },
      { word: 'Was invented', pron: '/wʌz ɪnˈventɪd/', trans: 'Fue inventado/a', ex: 'The printing press was invented in 1440.' }
    ],
    3: [
      { word: 'Passport', pron: '/ˈpæspɔːrt/', trans: 'Pasaporte', ex: 'You need a passport to travel abroad.' },
      { word: 'Tourist', pron: '/ˈtʊrɪst/', trans: 'Turista', ex: 'Tourists visit historical places.' },
      { word: 'Have visited', pron: '/hæv ˈvɪzɪtɪd/', trans: 'He/Hemos visitado (Presente Perfecto)', ex: 'I have visited Cartagena twice.' },
      { word: 'Has lived', pron: '/hæz lɪvd/', trans: 'Ha vivido', ex: 'She has lived in Medellín for 5 years.' }
    ],
    4: [ // U4: Futuro y Condicionales
      { word: 'Scholarship', pron: '/ˈskɑːlərʃɪp/', trans: 'Beca universitaria', ex: 'I will apply for a university scholarship.' },
      { word: 'Will pass', pron: '/wɪl pæs/', trans: 'Pasará / Pasaré (Futuro)', ex: 'If I study, I will pass the ICFES exam.' },
      { word: 'Going to', pron: '/ˈɡoʊɪŋ tuː/', trans: 'Ir a (Plan futuro)', ex: 'She is going to study medicine.' }
    ],
    5: [ // U5: Modales e ICFES
      { word: 'Must', pron: '/mʌst/', trans: 'Deber / Obligación estricta', ex: 'Students must follow school rules.' },
      { word: 'Should', pron: '/ʃʊd/', trans: 'Debería (Consejo)', ex: 'You should practice English daily.' },
      { word: 'Have to', pron: '/hæv tuː/', trans: 'Tener que', ex: 'We have to complete the workshop.' }
    ]
  }
};

export default function VocabularyDictionary() {
  const [selectedGrade, setSelectedGrade] = useState('6');
  const [selectedUnit, setSelectedUnit] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  const wordList = DICTIONARY_DATABASE[selectedGrade]?.[selectedUnit] || [];

  // Función para síntesis de voz nativa (Text-to-Speech)
  const speakText = (text) => {
    if (!('speechSynthesis' in window)) {
      alert("Tu navegador no soporta la síntesis de voz.");
      return;
    }
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'en-US';
    utterance.rate = 0.85;
    window.speechSynthesis.speak(utterance);
  };

  // Filtrado de palabras en tiempo real por búsqueda
  const filteredWords = wordList.filter(item => 
    item.word.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.trans.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6 text-slate-100">
      
      <div className="flex items-center justify-between border-b border-slate-800 pb-4">
        <div>
          <h3 className="text-xl font-bold text-white">📖 Diccionario Olayista - Vocabulario Institucional</h3>
          <p className="text-xs text-slate-400 mt-1">Palabras clave, guía de pronunciación en audio, traducción y oraciones de ejemplo</p>
        </div>
      </div>

      {/* FILTROS Y BARRA DE BÚSQUEDA */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {/* Selector de Grado */}
        <div>
          <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Grado:</label>
          <select 
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
            className="w-full bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-blue-500 cursor-pointer"
          >
            <option value="6">Grado 6°</option>
            <option value="7">Grado 7°</option>
            <option value="9">Grado 9°</option>
          </select>
        </div>

        {/* Selector de Unidad */}
        <div>
          <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Unidad:</label>
          <select 
            value={selectedUnit}
            onChange={(e) => setSelectedUnit(Number(e.target.value))}
            className="w-full bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-blue-500 cursor-pointer"
          >
            <option value={1}>Unidad 1</option>
            <option value={2}>Unidad 2</option>
            <option value={3}>Unidad 3</option>
            <option value={4}>Unidad 4</option>
            <option value={5}>Unidad 5</option>
          </select>
        </div>

        {/* BUSCADOR EN TIEMPO REAL */}
        <div>
          <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Buscar Término:</label>
          <input 
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="🔍 Buscar en inglés o español..."
            className="w-full bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-blue-500"
          />
        </div>
      </div>

      {/* LISTADO DE PALABRAS EN TARJETAS CON EJEMPLOS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filteredWords.length > 0 ? (
          filteredWords.map((item, idx) => (
            <div key={idx} className="bg-slate-950/80 border border-slate-800 p-4 rounded-2xl space-y-3 hover:border-slate-700 transition shadow-sm">
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="text-base font-extrabold text-blue-400">{item.word}</h4>
                  <span className="text-[11px] font-mono text-slate-400 block mt-0.5">{item.pron}</span>
                </div>
                <span className="bg-blue-600/20 text-blue-300 text-[10px] font-bold px-2.5 py-0.5 rounded-full border border-blue-500/30">
                  {item.trans}
                </span>
              </div>

              <div className="bg-slate-900/60 p-2.5 rounded-xl border border-slate-800/80">
                <p className="text-xs text-slate-300 italic">
                  &quot;{item.ex}&quot;
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-2 p-8 text-center text-xs text-slate-400 bg-slate-950/40 rounded-2xl border border-slate-800">
            No se encontraron palabras para la búsqueda &quot;{searchTerm}&quot; en la Unidad {selectedUnit} de Grado {selectedGrade}°.
          </div>
        )}
      </div>

    </div>
  );
}